import quotes from '../quotes.json';

let bodyStyle = {
    backgroundImage: `url(/doujinarchive/img/windowbg.jpg)`,
    backgroundRepeat: `no-repeat`
};

export default function BlogMenu(props) {
    return(
        <div>
            <div className="window">
            <div className="window-title">
                <img alt="window icon" src={`/doujinarchive/ico/AYUFUSI.png`} className="window-icon"/>
                {quotes[Math.floor(Math.random() * quotes.length)]}
            </div>
            <div className="window-body" style={bodyStyle}>
                <table className="header-table">
                    <tr className="header-row">
                        <td>
                            <img alt="cover art" className="cover-art" src={`/doujinarchive/img/Welcome.png`}/>
                        </td>
                        <td className="game-info">
                            <h2>Research and Translation</h2>
                            <h6 className="maker">Learning is fun, 2025</h6>
                            <p className="description">Welcome to my research and translation blog. Here, you'll find posts about whatever piques my interest. I may occasionally even upload translation patches.</p>
                            <p>日本のゲームは人生が大きく変わった</p>
                        </td>
                    </tr>
                </table>
                <div className="controls">
                    <a href="http://hoshikawa-aru.com"><button>Aru</button></a>
                    <a href="https://bigbadboyyo.neocities.org"><button>Frank</button></a>
                    <a href="#"><button onClick={() => {props.chng('Archive')}}>Archive</button></a>
                </div>
            </div>
        </div>

        <div className="window">
            <div className="window-title">
            <img alt="window icon" src={`/doujinarchive/ico/page.png`} className="window-icon"/>
            Post Menu
            </div>
            <div className="window-body menu-body" style={bodyStyle}>
            <a href="https://btuberbilly.github.io/doujinarchive?blog=1&doom=1"><button className="winbtn">Doomscroll Mode</button></a>
            {props.posts.map(post => {
                return(
                <div className="menu-item">
                <span className="menu-date">{post.year}</span>
                <a href={"https://btuberbilly.github.io/doujinarchive?post=" + post.postID}>{post.title}</a>
                </div>
                );
            })}
            </div>
        </div>
        </div>
    );
}